import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Aggiornato:',
  breadcrumbs: {
    home: 'Home',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Perché puoi fidarti di noi',
        details: {
          text: '<h2>Perché puoi fidarti di noi</h2><p>Gli articoli su Natu.Care sono scritti basandosi su ricerche scientifiche, dati provenienti da siti web governativi e altre fonti affidabili. I testi sono scritti in collaborazione con medici, nutrizionisti e altri esperti di salute e bellezza. Gli articoli vengono revisionati prima della pubblicazione e durante gli aggiornamenti significativi.</p>.',
          footerText: '<p>Scopri di più sul nostro <a href="/it/chi-siamo/processo-editoriale">processo editoriale</a></p>.'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informazioni sulle pubblicità',
        details: {
          text: '<h2>Informazioni sulle pubblicità</h2><p>I contenuti su Natu.Care possono contenere link a prodotti dalla cui vendita potremmo ricevere una commissione. Durante la creazione dei contenuti, aderiamo a elevati standard editoriali e ci preoccupiamo di essere obiettivi riguardo ai prodotti discussi. La presenza di link di affiliazione non è dettata dai nostri partner, e selezioniamo i prodotti che recensiamo in modo completamente indipendente.</p>.',
          footerText: '<p>Scopri di più sui nostri <a href="/it/termini-di-servizio">termini e condizioni</a></p>.',
        }
      }
    ],
    tooltip: {
      labelVerified: 'Verificato da un esperto',
      footerText: '<p>Scopri di più sul nostro <a href="/it/chi-siamo/processo-editoriale">processo editoriale</a></p>.'
    }
  },

  mediabar: {
    heading: 'Media su di noi:',
    href: '/it/chi-siamo',
    title: 'Media su di noi:',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Prenditi cura di un corpo sano',
    description: `Prova gli integratori di alta qualità di Natu.Care`,
    button: {label: 'Vedi i prodotti', href: 'https://natu.shop/collections'},
    picture: {alt: 'Giovani donne bellissime con una buona condizione della pelle'}
  },

  authorship: {
    heading: 'Redazionali',
    link: {
      label: 'Conosci il team',
      href: '/it/chi-siamo/comitato-editoriale'
    }
  },

  similarArticles: {
    headingBlogList: 'Articoli',
    headingBlogPost: 'Articoli simili'
  }  
};